import React from 'react'
import { ForwardRefExoticComponent, SVGProps } from 'react'

import { TextSize } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import TextElementQuestion from 'modules/forms/components/QuestionComponent/TextElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, elementParam } from 'modules/forms/lib/types'

/**
 * LongTextElement class for multi-line text input elements.
 * Extends the base Element class.
 */
export class LongTextElement extends Element {
  /**
   * Get the name of the element
   */
  getName(): string {
    return i18n.t('forms.modals.elements.text')
  }

  /**
   * Get the type of the element
   */
  getType(): FormsElementTypeEnum {
    return 'longtext'
  }

  /**
   * Get the icon for the element
   */
  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return TextSize
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <TextElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <TextElementQuestion element={this} onChange={onChange} />
  }

  configureParams(): elementParam[] {
    return [Element.numberParam('rows', 'Rows')]
  }
}
